import PropTypes from 'prop-types';

export const Icons = (props) => {
    const { icon = 'moto', className = '', fontSize, ...other } = props;

    return <span className={`icon-${icon} ${className}`} style={{ fontSize }} {...other} />;
};
